import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
// import Context from "../store/Context";
import VoucherViewer from "../VoucherViewer";
import pendingGif from "../../assests/computer.gif";
import { toast } from "react-toastify";
import { RotatingSquare } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
// import UserPendingVouchers from "./userPendingVouchers";

function UserPendingVouchers(props) {
  const [open, setOpen] = useState(false);
  const [Id, setId] = useState(null);
  const [PendingVoucherData, setPendingVoucherData] = useState(null);
  const [loadingPendingDAta, setLoadingPendingData] = useState(false);
  //   const ctx = useContext(Context);
  const user = JSON.parse(localStorage.getItem("token"));
  const connectionUrl = process.env.REACT_APP_BACKEND_URL;
  // const [id,setId]=useState(null)
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.post(
          `${connectionUrl}/user/getPendingvouchers`,
          {
            token: user.access_token,
            domain: user.domain,
          }
        );
        const res = response.data.userList;

        setPendingVoucherData(res);
        setLoadingPendingData(true);
        // if (response?.data?.userList) {
        //   ctx.AllVoucher(response.data.userList);
        // }
      } catch (err) {
        console.log(err);
        toast.error("something went wrong ...try after sometime");
      }
    }
    fetchData();
  }, []);
  const selectedTheme = "modern reelosid";
  const navigate = useNavigate();
  return (
    <>
      {!loadingPendingDAta && (
        <div className="flex flex-col justify-center items-center h-[calc(100vh-120px)] font-bold text-[1.2rem]">
          <RotatingSquare
            visible={true}
            height="100"
            width="100"
            color="#2980b9"
            ariaLabel="rotating-square-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
          <p>fetching tour vouchers ...</p>
        </div>
      )}{" "}
      {loadingPendingDAta && (
        <VoucherViewer
         close={() => {
            setOpen(!open);
          }}
          voucherId={Id}
          open={open}
        ></VoucherViewer> 
      )}
      {loadingPendingDAta && (
        <section
          className={`${
            selectedTheme === "modern reeloid"
              ? "bg-black/40 backdrop-blur-lg "
              : "bg-[#2A3042] "
          } py-2  rounded-md m-4 mt-8`}
        >
          <div className="flex justify-between p-4 border-b-2">
            <p className="text-white text-[1.2rem] font-bold">Your Vouchers</p>
            <input
              placeholder="Search Voucher Here"
              className="px-2 rounded"
            ></input>
          </div>
          <div className="flex gap-6 flex-col xl:flex-row">
            <div
              className={` ${
                selectedTheme === "modern reeloid"
                  ? "bg-black/40 backdrop-blur-lg "
                  : "bg-[#2A3042] "
              } flex-1  rounded-md text-gray-200 max-md:overflow-auto py-2`}
            >
              <div className=" font-normal text-[.9rem] min-w-[740px]">
                <div className="font-semibold flex border-b pb-2 border-gray-500">
                  <div className="w-[100px] flex flex-shrink-0 items-center">
                    <p className="px-4">Id</p>
                  </div>

                  <div className="w-[100%] flex flex-shrink-1 min-w-[100px] mx-8">
                    <p className="p-2">Trip</p>
                  </div>
                  <div className="w-[180px] flex flex-shrink-0 items-center">
                    <p className="px-4">Date</p>
                  </div>
                  <div className="w-[240px] flex flex-shrink-0">
                    <p className="p-2">Status</p>
                  </div>
                </div>
                {PendingVoucherData?.length > 0 &&
                  PendingVoucherData.map((current, index) => {
                    return (
                      <div
                        className="hover:cursor-pointer hover:bg-yellow-600 font-normal flex my-2 text-gray-200 border-b border-gray-500  shadow-lg hover:scale-95 hover:shadow-xl transition-transform duration-200"
                        onClick={() => {
                          setOpen(true);
                          setId(current.id);
                        }}
                      >
                        <div className="w-[100px] px-2  flex-shrink-0">
                          <p className="p-2">{current.id}</p>
                        </div>
                        <div className="w-[100%]  flex-shrink-1 min-w-[100px] flex  items-center mx-8">
                          <p className="p-2">{current.tourLocation}</p>
                        </div>{" "}
                        <div className="w-[180px] px-2  flex-shrink-0">
                          <p className="p-2">{current.tourDate || "-"}</p>
                        </div>
                        <div className="w-[240px] flex flex-shrink-0">
                          <p className="p-2 text-wrap whitespace-normal break-words w-[100%]">
                            {current.statusType}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default UserPendingVouchers;
